@if (stars) {
  <div class="stars-container">
    @for (star of stars; track star; let i = $index) {
      @if (star < starsRate) {
        <span
          [inlineSVG]="selectedStarIcon"
          class="star-icon"
          title="Selected star"
          (click)="starClicked(index, star + 1)"
          [matTooltip]="'global.' + titlesDesc + '_' + (i + 1) | transloco"
          [matTooltipPosition]="'above'"
        >
        </span>
      }
      @if (star >= starsRate) {
        <span
          [inlineSVG]="emptyStarIcon"
          class="star-icon empty-star"
          title="Empty star"
          (click)="starClicked(index, star + 1)"
          [matTooltip]="'global.' + titlesDesc + '_' + (i + 1) | transloco"
          [matTooltipPosition]="'above'"
        >
        </span>
      }
    }
  </div>
}
